import { Typography } from '@mui/material'
import { Store } from 'models'

interface StoreNameProps {
  store?: Store
}

export const StoreName = ({ store }: StoreNameProps) => {
  return (
    <Typography color="primary" variant="h1">
      {store?.name}
    </Typography>
  )
}
